// Stable, readable URLs for the service pages. Keep pillar slugs unchanged
// so existing shared links to /capabilities/:slug remain valid.
export const serviceSlug = (label = "") => label.toLowerCase().normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "").replace(/&/g, " and ")
  .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const serviceUrl = (pillarSlug, label) =>
  `/capabilities/${pillarSlug}/${serviceSlug(label)}`;
